import {createContext, useContext} from 'react';

export interface ProcedureRunDesignFlowchartAddReplicateContextValue {
  /** Adds a new condition-replicate lane (a draft group covering the active + downstream methods). */
  onAdd: () => void;
  /** When true, the button is dimmed and clicks are no-ops (e.g. at the replicate limit). */
  isDisabled: boolean;
  /** Tooltip explaining why the button is disabled. Only shown while {@link isDisabled} is true. */
  disabledTooltipText?: string;
}

/**
 * Add-replicate wiring for the flowchart button node. Threaded via context (rather than node `data`) so
 * the callback/disabled state can change without re-triggering layout. Defaults are inert so any render
 * outside the editor does nothing (the no-op `onAdd` guarantees inertness regardless of `isDisabled`).
 */
export const ProcedureRunDesignFlowchartAddReplicateContext =
  createContext<ProcedureRunDesignFlowchartAddReplicateContextValue>({
    onAdd: () => {},
    isDisabled: false,
  });

/** Reads the add-replicate callback for the flowchart button node. */
export function useProcedureRunDesignFlowchartAddReplicate(): ProcedureRunDesignFlowchartAddReplicateContextValue {
  return useContext(ProcedureRunDesignFlowchartAddReplicateContext);
}
